export const NAV_DEFAULT_SEARCH_PARAMS: Record<string, Record<string, string>> = {
  '/monitoring/events': {
    status: '6',
    createdAt: 'preset:30m',
  },
  '/events': {
    status: '6',
    createdAt: 'preset:30m',
  },
}
